import { Controller, Control } from 'react-hook-form'
import { TextFieldProps, Box, IconButton } from '@mui/material'
import InputField from '../common/input/InputField'

type FormInputProps = {
  name: string
  label?: string
  control: Control<any>
  required?: boolean
  errorMessage?: string
  onClear?: () => void
  transformValue?: (value: string) => string
  clearErrors?: (name?: string | string[]) => void
} & TextFieldProps

export const FormInput = ({
  name,
  label,
  control,
  errorMessage,
  required,
  onClear,
  transformValue,
  slotProps,
  clearErrors,
  ...props
}: FormInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const existingSlotProps = slotProps && typeof slotProps === 'object' ? slotProps : {}

        const existingInputProps =
          existingSlotProps.input && typeof existingSlotProps.input === 'object' ? existingSlotProps.input : {}

        const mergedSlotProps = {
          ...existingSlotProps,
          input: {
            ...existingInputProps,
            endAdornment: (
              <>
                {existingInputProps.endAdornment}
                {field.value && onClear ? (
                  <Box>
                    <IconButton
                      onClick={() => {
                        onClear?.()
                        field.onChange('')
                      }}
                      aria-label='clear selection'
                      tabIndex={-1}
                    >
                      <i className='tabler-circle-x text-[16px] text-textPrimary'></i>
                    </IconButton>
                  </Box>
                ) : null}
              </>
            )
          }
        }

        const handleChange: NonNullable<typeof field.onChange> = (event: any) => {
          const rawValue =
            typeof event === 'object' && event !== null && 'target' in event ? (event as any).target?.value : event
          const nextValue = typeof rawValue === 'string' && transformValue ? transformValue(rawValue) : rawValue
          if (name === 'phone' && clearErrors) {
            clearErrors('phone_code')
          }
          field.onChange(nextValue)
          // Preserve external onChange if provided via props

          if (typeof props.onChange === 'function') {
            ;(props.onChange as any)(event)
          }
        }

        return (
          <InputField
            {...props}
            {...field}
            label={label}
            required={required}
            error={!!errorMessage || !!fieldState.error}
            helperText={errorMessage || fieldState.error?.message}
            onBlur={field.onBlur}
            onChange={handleChange}
            slotProps={mergedSlotProps}
          />
        )
      }}
    />
  )
}

export default FormInput
